import React from 'react';
import connect from '@src/js/separate-logic/connect';
import styles from '../../../../scale-slide.css';
import { browser } from '@src/slide/infrastructure/module/independent/agent/common';
import AddonScaleViewPresenter from './addon-scale-view-presenter';
import { getAddonScaleViewUniqueName } from '../utils';
import i18n from '@i18next/i18n';
import type { AddonWhitelist } from '@tencent/td-addon-sdk-docs';
import AddonLoading from '../addon-loading';

export const DEFAULT_ADDON_SCALE_SIZE = { // 定义占位图的边界值
    MIDDLE: 500,
    SMALL: 100,
};

export const SNAPSHOT_ADDON_SCALE_SIZE = {
    MIDDLE: 800,
    SMALL: 288,
};

interface IAddonScaleViewProps {
    setRef: (name: string, ref: any) => void;
    size: any;
    scaleViewHidden: boolean;
    mobileEditMode: boolean;
    snapshotUrl: string | null;
    addonName: string | null;
    addonIcon: string | null;
    isInIframeRenderWhiteList: boolean;
    miniAppRenderWhitelist: AddonWhitelist[] | null;
    isVideoType: boolean;
    handleMiniProgramCopyLink: any;
    src: string;
    addon: any;
}
export class AddonScaleView extends React.Component<IAddonScaleViewProps> {
    public static defaultProps = {
        setRef: () => {},
    };

    public addonClassName: string;

    public constructor(props) {
        super(props);
        this.addonClassName = getAddonScaleViewUniqueName();
    }

    public render() {
        const { size, scaleViewHidden, mobileEditMode, snapshotUrl, miniAppRenderWhitelist } = this.props;
        if (browser.isMiniProgram && !miniAppRenderWhitelist) {
            return <AddonLoading loadCover={miniAppRenderWhitelist === null} />;
        }
        return (
            <div className={styles[`${this.addonClassName}-wrapper`]} style={{
                width: size.width,
                height: size.height,
                display: scaleViewHidden ? 'none' : 'block',
            }}
            id={this.addonClassName}
            >
                {snapshotUrl ? this.renderSnapShotView() : this.renderDefaultView(size, mobileEditMode)}
            </div>
        );
    }

    /**
     * 渲染占位图方案
     * @param size 插件大小
     * @param mobileEditMode 移动端编辑态判断
     */
    private renderDefaultView = (size, mobileEditMode: boolean) => {
        const { setRef, isInIframeRenderWhiteList } = this.props;
        const { textLessSmallHidden, inPcIconHide } = this.getDefaultViewShowStyle(size);
        // 预览态文案 点击预览内容
        // 编辑态文案 演示模式可查看
        const mobilePreviewText = mobileEditMode ? i18n.t('点击预览内容') : i18n.t('演示模式可查看');
        const isMiniRender = browser.isMiniProgram && !isInIframeRenderWhiteList;
        return !inPcIconHide
            ? <>
                <div className={styles[`${this.addonClassName}-content`]} ref={ref => setRef('contentRef', ref)}>
                    <i className={styles[`${this.addonClassName}-icon`]} />
                    {/* 非移动端 或 小程序非白名单 需要隐藏提示文案 */}
                    {!textLessSmallHidden && <p hidden={!browser.isMobile || isMiniRender}>{mobilePreviewText}</p>}
                </div>
                {/* 小程序非白名单需要展示底部提示 */}
                {isMiniRender && this.getSnapShotBannerShowStyle(size.width)}
            </> : null;
    };

    /**
     * 渲染截图方案
     */
    private renderSnapShotView = () => {
        const { size, snapshotUrl, isInIframeRenderWhiteList } = this.props;
        const { width = 0, height = 0 } = size;
        return <>
            <div className={styles[`${this.addonClassName}-snapshot`]} style={{
                backgroundImage: `url(${snapshotUrl})`,
                width,
                height,
                backgroundSize: '100% 100%',
            }} />
            {(browser.isMiniProgram && !isInIframeRenderWhiteList) && this.getSnapShotBannerShowStyle(width)}
        </>;
    };

    /**
     * 根据插件长宽不同显示不同的图标文案
     * @param size 插件尺寸对象
     */
    private getDefaultViewShowStyle = (size) => {
        let textLessSmallHidden = false;
        let inPcIconHide = false;
        if (size.width < DEFAULT_ADDON_SCALE_SIZE.MIDDLE || size.height < DEFAULT_ADDON_SCALE_SIZE.MIDDLE) {
            textLessSmallHidden = true;
        }
        if (size.width < DEFAULT_ADDON_SCALE_SIZE.SMALL || size.height < DEFAULT_ADDON_SCALE_SIZE.SMALL) {
            inPcIconHide = true;
        }
        return { textLessSmallHidden, inPcIconHide };
    };

    /**
     * 根据插件长度不同决定不同文案
     * @param width 插件长度
     */
    private getSnapShotBannerShowStyle = (width) => {
        const { setRef, isVideoType, addonIcon, addonName } = this.props;
        const title = addonName ?? i18n.t('第三方插件');
        let dom = <>{i18n.t('小程序不支持')}{isVideoType ? i18n.t('播放') : i18n.t('查看')}，{this.getCopyLinKDom()}</>;
        if (width < SNAPSHOT_ADDON_SCALE_SIZE.MIDDLE && width > SNAPSHOT_ADDON_SCALE_SIZE.SMALL) {
            dom = this.getCopyLinKDom();
        } else if (width < SNAPSHOT_ADDON_SCALE_SIZE.SMALL) {
            dom = <></>;
        }
        return (
            <div key={`${this.props.mobileEditMode}`} id={`${this.addonClassName}-banner`} ref={ref => setRef('bannerRef', ref)}>
                <div className={styles[`${this.addonClassName}-banner-bottom`]} >
                    <div className={styles['left-thumbnail']}>
                        {addonIcon
                            ? <img src={addonIcon} style={{ width: '88px', height: '88px' }} />
                            : <i className={styles['default-image']} />
                        }
                    </div>
                    <div className={styles['right-panel']}>
                        <div className={styles['banner-bottom--title']}>{title}</div>
                        <div className={styles['banner-bottom--tips']}>{dom}</div>
                    </div>
                </div>
            </div>
        );
    };

    private getCopyLinKDom = () => <><span onTouchEnd={this.props.handleMiniProgramCopyLink}>{i18n.t('复制链接')}</span>{i18n.t('去浏览器查看。')}</>;
}

export default connect(
    AddonScaleViewPresenter,
    null,
    AddonScaleView,
);
